import React from "react";
import Table from "../../../../../components/Table";
import { connect } from "react-redux";
import { citiesPageLoad } from "../../../actions/cities";
import { cities, citiesLoadInProgress } from "../../../selectors/cities";
import PageTitle from "../../../components/PageTitle";
import { push } from "react-router-redux";
import { Button, Glyphicon, Panel } from "react-bootstrap";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import DisableBadge from "sc/ui/sites/oncall/components/DisableBadge";

export default connect(
  (state, ownProps) => ({
    cities: cities(state),
    loading: citiesLoadInProgress(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(citiesPageLoad()),
    onAddCiy: () => dispatch(push("cities/new")),
    onEditCity: id => dispatch(push(`/city/edit/${id}`)),
  }),
)(
  componentWithLoadTrigger(props => {
    const actions = [
      {
        id: "edit-city",
        text: " Edit",
        className: "btn-primary",
        glyph: "glyphicon glyphicon-pencil",
        onClick: props.onEditCity,
      },
    ];

    const columns = [
      {
        header: "City",
        data: city => `${city.name}/${city.state}`,
        badges: city => {
          const allBadges = [];
          if (!city.enabled)
            allBadges.push([<DisableBadge key="disabled-badge" />]);
          return allBadges;
        },
      },
      {
        header: "Region",
        data: city => city.regionName,
      },
    ];

    return (
      <div id="cities-list-page">
        <PageTitle title="Cities" />
        <Button id="add-city" onClick={props.onAddCiy} className="btn-success">
          <Glyphicon glyph="glyphicon glyphicon-plus" />
          &nbsp;Add New City
        </Button>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Cities list</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Table
              data={props.cities}
              columns={columns}
              actions={actions}
              identityProperty="id"
              noDataMessage="No cities defined"
              loading={props.loading}
              loadingMessage="Loading..."
            />
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/cities/List.js